module.exports = __webpack_public_path__ + "static/img/db99119779d3d8aeaacff32599f7f353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extract_model.png
// module id = f7Ob
// module chunks = 1